<template>
  <div id="hyppo-card-list">
    <b-list-group v-if="items">
      <b-list-group-item
        v-for="(item, index) in items" :key="item.code"
        class="d-flex justify-content-between align-items-center">
        <div class="row">
          <div class="col-sm-2">
            <b-badge pill variant="light">{{item.code}} </b-badge>
            <b-badge v-show="item.delivery_date" pill variant="info">{{item.delivery_date}} </b-badge>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>

import server from '../../../api/server.vue'
import {Steps} from '../../../core/services/steps.js'
import moment from 'moment'

export default {
  name: 'BlList',
  props: ['items']
};
</script>

<style scoped>
  .list-group-item {
    padding: 5px 30px 5px 30px;
  }
  #hyppo-card-list {
    width: 50%;
    margin-left: 75%;
    height: 250px;
    overflow-y: auto;
  }
  #hyppo-card-list .row {
    width: 250px;
    /*padding: 5px;*/
  }
  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4 {
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/andon/detailed/BlList.vue